import React from 'react';
import { Alert, Card, Typography } from 'antd';

const { Title, Paragraph } = Typography;

const FundedTrainingSection = () => (
    <Card style={{ marginBottom: '24px' }}>
        <Title level={4}>TT Funded Training Accounts</Title>
        <Alert
            message="Auto-Created Accounts"
            description="Your TT Funded Training accounts are automatically created when you receive funding.
              No manual setup is required - they'll appear in your accounts list once activated."
            type="info"
            showIcon
            style={{ marginBottom: '16px' }}
        />
        <Paragraph>
            These accounts are designed for funded traders to track their performance and maintain
            compliance with trading requirements. All trades are automatically recorded and analyzed
            in the Journal.
        </Paragraph>
    </Card>
);

export default FundedTrainingSection;
